<div class="container update-members main width-alignment">
    <div class="col-12 Individual createGroup">
        <div class="update-group">
                      <!-- <span (click)="back()"><i class="fa fa-angle-left goback" aria-hidden="true"></i></span> -->
        <label for="select" class="lable-size labelaccess">Update Member Access - {{relname}}</label>
    </div>
        <!--Relation Ipdate Groups-->
        <div class="row">
            <div class="col-3"></div>
            <div class="col-6" *ngIf="product ==='corporate' || product ==='content' || product ==='connect'">
                <div class="form-group" id="selectbx">
                  <div class="input-group group-custom-align court" *ngFor="let grp of groupList" style="margin-bottom:3px;">
                    <div class="multicheck form-control textbox">
                      <div class="callselect" [innerHtml]="grp.name"></div>
                        <input class="form-check-inpu calimg calitem input-group-app end checkboxitem" #inputEl
                        [ngClass]="{'active': selectedIds.includes(grp.id)}" 
                        [checked]="selectedIds.includes(grp.id)" type="checkbox"
                        (change)="selectCorporateGrp(grp, inputEl.checked)"> 
                      </div>
                  </div>
                </div>
            </div>
            <div class="col-12 createGroup">
              <div class="row">
                <div class="col-6 matterpadding">
                  <h5 class="float-left grpFont">Selected Member(s)</h5>
                  <div class="selectedone">
                    <div class="form-group group-custom-align" *ngFor="let group of selectedGroups">
                      <div class="input-group multicheck court" id="selectedgroup">
                        <div style="margin-bottom: 10px;" class="form-control textbox" [innerHtml]="group.name"></div>
                        <i class="fa fa-regular fa-circle-xmark calimg calitem input-group-append sgroup" aria-hidden="true"
                        (click)="removeGroup(group);searchText = ''"></i>
                    </div>
                  </div>
                  </div>
                </div>
                <div class="col-6 matterpadding">
                  <h5 class="float-left grpFont">Assign to Member(s)<span class="mandate">*</span></h5>
                  <div class="col-3" *ngIf="!isEdit">
                    <div class="form-group" id="selectbx">
                      <div class="input-group court" id="search">
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group">
                    <div class="input-group group-custom-align court" id="search" *ngIf ="product !='corporate'">
                      <input type="text" class="form-control textbox searchtext" placeholder="Search Member" [(ngModel)]="searchText" (keyup)="keyup()" />
                      <img src="assets/img/search.svg" class="calimg calitem input-group-append searchimg">
                    </div>
                  </div>
          
                  <div class="form-group" id="selectbx">
                    <div class="input-group group-custom-align court matterpadding" id="search"
                      *ngFor="let group of filteredData | filter:searchText">
                      <div class="multicheck form-control textbox">
                        <div class="callselect" [innerHtml]="group.name"></div>
                          <input class="form-check-inpu calimg calitem input-group-app end checkboxitem" 
                          #inputEl type="checkbox" (change)="selectGrp(group, inputEl.checked)"> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <!--Relation Update Groups-->
     <div class="btnbox">
        <button type="button" class="btn btn-default btncancel" (click)= "cancel()">Cancel</button>
        <button type="button" class="btn btn-default btnsave" [disabled]="isSaveDisabled" (click)="confirmSave()">Save</button>
     </div>
</div>
<div class="modal"
     *ngIf='showConfirm'
     style="display:block;" 
     tabindex="-1">
  <div class="modal-dialog">
      <div class="modal-content">
        
              <button type="button"
                      class="btn-close"
                      data-bs-dismiss="modal" (click)="showConfirm = false;" aria-label="Close"></button>

          <div class="modal-body">
              <div class="alertpara">
                  <p class="alertparatxt">Confirmation</p>
                </div>
          </div>

          <div class="alertext" style="height:130px;">
            Are you sure you want to modify the Member access for <strong>{{reldata.name}}</strong>.
          </div>

          <div class="alertbutton">
              <button class="btn btn-default  alertbtn alertbtnno"
                      data-bs-dismiss="modal"
                      (click)="showConfirm = false;"
                      aria-label="Close">No</button>
              <button class="btn btn-default alertbtn alertbtnyes"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      (click)="save()">Yes</button>
          </div>
      </div>
  </div>
</div>